import AbstractChannel from './AbstractChannel'

export default class RealTimeReservation extends AbstractChannel {

  name = 'real_time_reservations'
  title = 'RealTime Reservation'
  titleShort = 'RTR'
  color = '#C5B0D5'

  supportedFeatures = ['blackouts']

}
